(() => {
  const header = document.querySelector('[data-maison-yara-header]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const markLoaded = () => {
    document.documentElement.classList.add('is-loaded');
  };

  if (document.readyState === 'complete') {
    markLoaded();
  } else {
    window.addEventListener('load', markLoaded, { once: true });
  }

  if (!header) return;

  const mobileMenu = header.querySelector('[data-mobile-menu]');
  const mobileMenuToggle = header.querySelector('[data-mobile-menu-toggle]');
  const mobileMenuLabel = header.querySelector('[data-mobile-menu-label]');
  const mobileBag = header.querySelector('.my-header__bag--mobile');
  const headerBrand = header.querySelector('.my-header__brand');
  const desktopQuery = window.matchMedia('(min-width: 761px)');
  let menuOpen = false;
  let lastFocused = null;
  let hideMenuTimer = null;
  let headerFrame = null;
  const heroLogo = header.dataset.homeHeader === 'true' ? document.querySelector('.my-hero__logo') : null;
  const useHeroTrigger = Boolean(heroLogo);

  const setHeaderState = () => {
    const headerHeight = header.getBoundingClientRect().height || 0;
    const logoBottom = heroLogo.getBoundingClientRect().bottom;

    header.classList.toggle('is-scrolled', logoBottom <= headerHeight);
  };

  const requestHeaderState = () => {
    if (headerFrame) return;

    headerFrame = window.requestAnimationFrame(() => {
      headerFrame = null;
      setHeaderState();
    });
  };

  if (useHeroTrigger) {
    setHeaderState();
    window.addEventListener('scroll', requestHeaderState, { passive: true });
    window.addEventListener('resize', requestHeaderState);
    window.addEventListener('load', setHeaderState, { once: true });
  } else {
    header.classList.add('is-scrolled');
  }

  if (!mobileMenu || !mobileMenuToggle || !mobileMenuLabel) return;

  const openLabel = mobileMenuLabel.dataset.openLabel || 'Menu';
  const closeLabel = mobileMenuLabel.dataset.closeLabel || 'Close';
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  const getFocusableMenuItems = () => {
    const items = [
      mobileMenuToggle,
      headerBrand,
      mobileBag,
      ...mobileMenu.querySelectorAll(focusableSelector),
    ];

    return items.filter((item) => {
      if (!item || !item.getClientRects().length) return false;

      return window.getComputedStyle(item).visibility !== 'hidden';
    });
  };

  const setMenuLabel = (isOpen) => {
    mobileMenuLabel.textContent = isOpen ? closeLabel : openLabel;
  };

  const openMenu = () => {
    if (menuOpen) return;

    menuOpen = true;
    lastFocused = document.activeElement;
    window.clearTimeout(hideMenuTimer);

    mobileMenu.hidden = false;
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileMenuToggle.setAttribute('aria-expanded', 'true');
    header.classList.add('is-menu-open');
    document.body.classList.add('my-mobile-menu-open');
    setMenuLabel(true);

    window.requestAnimationFrame(() => {
      mobileMenu.classList.add('is-open');
      const firstPanelLink = mobileMenu.querySelector('.my-mobile-menu__nav a');
      (firstPanelLink || mobileMenuToggle).focus({ preventScroll: true });
    });
  };

  const closeMenu = (restoreFocus = true) => {
    if (!menuOpen) return;

    menuOpen = false;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenuToggle.setAttribute('aria-expanded', 'false');
    header.classList.remove('is-menu-open');
    document.body.classList.remove('my-mobile-menu-open');
    setMenuLabel(false);

    const hideMenu = () => {
      if (!menuOpen) {
        mobileMenu.hidden = true;
      }
    };

    if (reduceMotion.matches) {
      hideMenu();
    } else {
      hideMenuTimer = window.setTimeout(hideMenu, 280);
    }

    if (restoreFocus && lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
    }
  };

  const trapMenuFocus = (event) => {
    const focusableItems = getFocusableMenuItems();

    if (!focusableItems.length) return;

    const firstItem = focusableItems[0];
    const lastItem = focusableItems[focusableItems.length - 1];

    if (event.shiftKey && document.activeElement === firstItem) {
      event.preventDefault();
      lastItem.focus();
    } else if (!event.shiftKey && document.activeElement === lastItem) {
      event.preventDefault();
      firstItem.focus();
    }
  };

  mobileMenuToggle.addEventListener('click', () => {
    if (menuOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  mobileMenu.addEventListener('click', (event) => {
    if (event.target.closest('a[href]')) {
      closeMenu(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!menuOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu();
    } else if (event.key === 'Tab') {
      trapMenuFocus(event);
    }
  });

  const handleDesktopChange = (event) => {
    if (event.matches) {
      closeMenu(false);
    }
  };

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', handleDesktopChange);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(handleDesktopChange);
  }
})();

(() => {
  const carousels = document.querySelectorAll('[data-my-pdp-carousel]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const updateAddLabel = (scope = document) => {
    scope.querySelectorAll('.my-pdp__add-button[data-add-label]').forEach((button) => {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      const label = button.querySelector('span');
      if (label) label.textContent = button.dataset.addLabel;
    });
  };

  carousels.forEach((carousel) => {
    const track = carousel.querySelector('[data-my-pdp-carousel-track]');
    const previous = carousel.querySelector('[data-my-pdp-carousel-prev]');
    const next = carousel.querySelector('[data-my-pdp-carousel-next]');

    if (!track || !previous || !next) return;

    let frame = null;

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    const requestButtonUpdate = () => {
      if (frame) return;

      frame = window.requestAnimationFrame(() => {
        frame = null;
        updateButtons();
      });
    };

    const move = (direction) => {
      track.scrollBy({
        left: direction * track.clientWidth,
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', requestButtonUpdate, { passive: true });
    window.addEventListener('resize', requestButtonUpdate);
    updateButtons();
  });

  updateAddLabel();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const scope = Array.from(document.querySelectorAll('product-info[data-section]')).find(
        (productInfo) => productInfo.dataset.section === data.sectionId
      );

      updateAddLabel(scope || document);
    });
  }
})();

(() => {
  const root = document.querySelector('[data-maison-yara-cookie-consent]');
  if (!root || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  const notice = root.querySelector('[data-cookie-notice]');
  const preferences = root.querySelector('[data-cookie-preferences]');
  const preferencePanel = root.querySelector('.my-cookie-consent__panel');
  const footerTriggers = document.querySelectorAll('[data-maison-yara-cookie-preferences]');
  const regionMode = root.dataset.regionMode || 'all_regions';
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');
  const consentKeys = ['analytics', 'marketing', 'preferences'];
  let customerPrivacy = null;
  let lastFocused = null;
  let noticeWasVisible = false;

  if (!notice || !preferences || !preferencePanel) return;

  const getFocusableItems = (scope) => {
    return Array.from(scope.querySelectorAll(focusableSelector)).filter((item) => {
      if (!item.getClientRects().length) return false;

      return window.getComputedStyle(item).visibility !== 'hidden';
    });
  };

  const getConsent = () => {
    if (!customerPrivacy || typeof customerPrivacy.currentVisitorConsent !== 'function') return {};

    return customerPrivacy.currentVisitorConsent() || {};
  };

  const hasConsentDecision = () => {
    const consent = getConsent();

    return consentKeys.some((key) => consent[key] === 'yes' || consent[key] === 'no');
  };

  const syncToggles = () => {
    const consent = getConsent();

    consentKeys.forEach((key) => {
      const toggle = root.querySelector(`[data-cookie-toggle="${key}"]`);
      if (toggle) toggle.checked = consent[key] === 'yes';
    });
  };

  const revealFooterTriggers = () => {
    footerTriggers.forEach((trigger) => {
      trigger.hidden = false;
    });
  };

  const setCustomUiActive = (isActive) => {
    document.body.classList.toggle('my-cookie-consent-active', isActive);
  };

  const hideRootIfIdle = () => {
    if (!notice.hidden || !preferences.hidden) return;

    root.hidden = true;
    setCustomUiActive(false);
  };

  const showNotice = () => {
    root.hidden = false;
    preferences.hidden = true;
    notice.hidden = false;
    setCustomUiActive(true);
    document.body.classList.remove('my-cookie-preferences-open');
  };

  const hideNotice = () => {
    notice.hidden = true;
    hideRootIfIdle();
  };

  const shouldShowNotice = () => {
    if (hasConsentDecision()) return false;

    if (
      regionMode === 'shopify_regions' &&
      customerPrivacy &&
      typeof customerPrivacy.shouldShowBanner === 'function'
    ) {
      return Boolean(customerPrivacy.shouldShowBanner());
    }

    return true;
  };

  const getLocalPreviewConsentOptions = () => {
    const localPreviewHosts = ['127.0.0.1', 'localhost', '::1'];
    if (!localPreviewHosts.includes(window.location.hostname)) return {};

    const featureScript = document.getElementById('shopify-features');
    if (!featureScript) return {};

    try {
      const features = JSON.parse(featureScript.textContent || '{}');

      if (!features.accessToken || !features.domain) return {};

      return {
        headlessStorefront: true,
        checkoutRootDomain: features.domain,
        storefrontRootDomain: window.location.hostname,
        storefrontAccessToken: features.accessToken,
      };
    } catch (error) {
      return {};
    }
  };

  const setTrackingConsent = (payload) => {
    if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') return;

    customerPrivacy.setTrackingConsent({ ...payload, ...getLocalPreviewConsentOptions() }, () => {
      notice.hidden = true;
      preferences.hidden = true;
      document.body.classList.remove('my-cookie-preferences-open');
      setCustomUiActive(false);
      root.hidden = true;
      revealFooterTriggers();
    });
  };

  const collectToggleConsent = () => {
    return consentKeys.reduce((payload, key) => {
      const toggle = root.querySelector(`[data-cookie-toggle="${key}"]`);
      payload[key] = Boolean(toggle && toggle.checked);

      return payload;
    }, {});
  };

  const acceptAll = () => {
    setTrackingConsent({
      analytics: true,
      marketing: true,
      preferences: true,
    });
  };

  const rejectAll = () => {
    setTrackingConsent({
      analytics: false,
      marketing: false,
      preferences: false,
    });
  };

  const saveChoices = () => {
    setTrackingConsent(collectToggleConsent());
  };

  const openPreferences = () => {
    lastFocused = document.activeElement;
    noticeWasVisible = !notice.hidden;
    syncToggles();

    root.hidden = false;
    notice.hidden = true;
    preferences.hidden = false;
    setCustomUiActive(true);
    document.body.classList.add('my-cookie-preferences-open');

    window.requestAnimationFrame(() => {
      const focusableItems = getFocusableItems(preferencePanel);
      (focusableItems[0] || preferencePanel).focus({ preventScroll: true });
    });
  };

  const closePreferences = () => {
    preferences.hidden = true;
    document.body.classList.remove('my-cookie-preferences-open');

    if (!hasConsentDecision() && noticeWasVisible) {
      notice.hidden = false;
    }

    hideRootIfIdle();

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
    }
  };

  const trapPreferenceFocus = (event) => {
    const focusableItems = getFocusableItems(preferencePanel);
    if (!focusableItems.length) return;

    const firstItem = focusableItems[0];
    const lastItem = focusableItems[focusableItems.length - 1];

    if (event.shiftKey && document.activeElement === firstItem) {
      event.preventDefault();
      lastItem.focus();
    } else if (!event.shiftKey && document.activeElement === lastItem) {
      event.preventDefault();
      firstItem.focus();
    }
  };

  root.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const closeButton = target.closest('[data-cookie-close]');
    if (closeButton) {
      closePreferences();
      return;
    }

    const action = target.closest('[data-cookie-action]');
    if (!action) return;

    if (action.dataset.cookieAction === 'accept') {
      acceptAll();
    } else if (action.dataset.cookieAction === 'reject') {
      rejectAll();
    } else if (action.dataset.cookieAction === 'customize') {
      openPreferences();
    } else if (action.dataset.cookieAction === 'save') {
      saveChoices();
    }
  });

  footerTriggers.forEach((trigger) => {
    trigger.addEventListener('click', openPreferences);
  });

  document.addEventListener('keydown', (event) => {
    if (preferences.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closePreferences();
    } else if (event.key === 'Tab') {
      trapPreferenceFocus(event);
    }
  });

  document.addEventListener('visitorConsentCollected', () => {
    if (hasConsentDecision()) {
      hideNotice();
      revealFooterTriggers();
    }
  });

  window.MaisonYaraCookieConsent = {
    openPreferences,
  };

  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    (error) => {
      if (error) return;

      customerPrivacy = window.Shopify.customerPrivacy;
      if (!customerPrivacy) return;

      revealFooterTriggers();

      if (shouldShowNotice()) {
        showNotice();
      }
    }
  );
})();
